(() => {
  class MenuSearch extends HTMLElement {
    constructor() {
      super();

      this.data = [];

      // Nodes
      this.input = null;
      this.output = null;

      // Event listeners
      this.handleTypingBound = this.handleTyping.bind(this);
    }

    reset() {
      this.input.value = "";
      this.renderLinks(this.data);
    }

    renderLinks(links, query = null) {
      const html = links
        .map((link) => {
          const title = query ? this.highlightMatch(link.title, query) : link.title;
          return `<li><a href="${link.url}">${title}</a></li>`;
        })
        .join("");

      this.output.innerHTML = html;
      this.classList.toggle("no-results", links.length === 0);
    }

    handleTyping() {
      const query = this.input.value.trim().toLowerCase();

      if (query.length < 1) {
        this.renderLinks(this.data);
        return;
      }

      // Filter links where title contains the query (case-insensitive)
      const matches = this.data.filter((link) =>
        link.title.toLowerCase().includes(query)
      );

      this.renderLinks(matches, query);
    }

    highlightMatch(text, query) {
      const regex = new RegExp(`(${this.escapeRegex(query)})`, "gi");
      return text.replace(regex, "<b>$1</b>");
    }

    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    connectedCallback() {
      this.input = this.querySelector("[data-menu-search-input]");
      this.output = this.querySelector("[data-menu-search-output]");

      if (!this.input || !this.output) {
        console.error("Input/Output not found");
        return;
      }

      try {
        const JSONScript = this.querySelector("[data-menu-search-data]");
        const parsedScript = JSON.parse(JSONScript.textContent);
        this.data = parsedScript.links;
      } catch (error) {
        this.data = null;
      }

      if (!this.data) {
        console.error("Data error");
        return;
      }

      this.input.addEventListener("keyup", this.handleTypingBound);
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener("keyup", this.handleTypingBound);
      }
    }
  }
  customElements.define("menu-search", MenuSearch);
})();
